module.exports = __webpack_public_path__ + "img/jindu1.c2f3bcc1.png";